var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheet2Red(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #1d1d1b;\r\n        stroke-width: .25px;\r\n      }\r\n\r\n      .st0, .st1 {\r\n        stroke: #474747;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #ea514a;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #474747;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,1.99c0-.55.45-.99,1-.99h17.01c.55,0,1.34.27,1.78.62l3.44,2.75c.43.34.78,1.07.78,1.62v26.01c0,.55-.45,1-1,1H6c-.55,0-1-.45-1-.99V1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,2h1v6h-1V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,7h6v1h-6v-1Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,2v5h5s.56-1.94-1.89-3.07-1.47-2.21-3.11-1.93Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet2Red);
export default __webpack_public_path__ + "static/media/sheet2red.88899dd3aaf4e5c5839372b18f3bc67e.svg";
export { ForwardRef as ReactComponent };